import { Box } from "@chakra-ui/react";
import TicketsByBranchTable from "../tables/TicketsByBranchTable";
import EnterpriseReportSummary from "../../reports/EnterpriseReportSummary";
import { buildTicketVolumeInsights } from "../../../store/reportEnterpriseInsights";


const TicketsByBranch = ({ reportIndex, data, renderConfig }) => {
  const insights = buildTicketVolumeInsights(data, { scopeLabel: "Branch" });

  return (
    <Box>
      <EnterpriseReportSummary
        title="Branch Ticket Distribution Summary"
        kpis={insights.kpis}
        tables={insights.tables}
        notes={insights.notes}
      />
      {data.map((branchData, index) => {
        return (
          <Box key={`${reportIndex}-${index}`} className="reportContainer" mt="20px">
            <TicketsByBranchTable
              index={index}
              branchData={branchData}
              reportIndex={reportIndex}
              renderConfig={renderConfig}
            />
          </Box>
        );
      })}
    </Box>
  );
};

export default TicketsByBranch;
